import * as React from 'react';
import { Button } from '../../components/Button';
var defaultConsentKey = 'cookie-consent';
var defaultPrivacyPolicy = 'https://smapiot.com/legal/privacy';
/**
 * A lightweight cookie consent popup.
 */
export var CookieConsent = function (_a) {
    var _b = _a.consentKey, consentKey = _b === void 0 ? defaultConsentKey : _b, _c = _a.privacyPolicy, privacyPolicy = _c === void 0 ? defaultPrivacyPolicy : _c;
    var _d = React.useState(function () { return !!localStorage.getItem(consentKey); }), consent = _d[0], setConsent = _d[1];
    var understood = React.useCallback(function () {
        localStorage.setItem(consentKey, new Date().toJSON());
        setConsent(true);
    }, []);
    return (!consent && (React.createElement("div", { className: "cookie-consent" },
        React.createElement("div", { className: "cookie-consent-container" },
            React.createElement("div", null,
                "Our website utilizes cookies for basic non-personalized analytics and error tracking. By using our website, you agree to our",
                ' ',
                React.createElement("a", { href: privacyPolicy, target: "_blank" }, "Privacy Policy"),
                ' ',
                "and our cookies usage."),
            React.createElement(Button, { onClick: understood }, "Understood")))));
};
//# sourceMappingURL=index.js.map